import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-embed-hint",
  role: "status"
}
const _hoisted_2 = {
  key: 1,
  id: "order-embed-detail-actions",
  class: "order-embed-detail-actions",
  "aria-label": "当前订单关键操作"
}

import {computed,onMounted,onBeforeUnmount,ref} from 'vue'
import {useRoute} from 'vue-router'
import service from '@/utils/request'
import {editingOrderTarget,orderWrite,orderDetailOpener} from '@/utils/orderDetailWindow'

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetailEmbed',
  setup(__props) {

// 仅嵌入“全部订单”的同源分类页；复用原页面、控件、接口和服务端权限。
const route=useRoute(),embedded=computed(()=>route.query.orderDetailEmbed==='1' && window.parent!==window),ready=ref(false),error=ref('')
const channel=String(route.query.detailChannel || '')
const started=Date.now()
let observer:MutationObserver|undefined,timer:ReturnType<typeof setInterval>|undefined,opening=false,pending=0,stopped=false,primary:HTMLElement|null=null
let requestId=-1
const baseline=new Map<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement,string>()
const writes=new Map<any,Map<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement,string>>()
const dirty=()=>Array.from(baseline).some(([el,value])=>el.isConnected && el.value!==value)
const subdialog=()=>Array.from(document.querySelectorAll<HTMLElement>('.ant-modal-wrap,.ant-drawer-open,.ant-select-dropdown,.ant-picker-dropdown,.ant-dropdown,.ant-popover,.row-action-panel')).some(el=>el!==primary && el.getAttribute('aria-hidden')!=='true' && el.getBoundingClientRect().height>0 && getComputedStyle(el).display!=='none' && !el.classList.contains('ant-select-dropdown-hidden') && !el.classList.contains('ant-picker-dropdown-hidden') && !el.classList.contains('ant-dropdown-hidden') && !el.classList.contains('ant-popover-hidden'))
function send(action:string,extra:any={}){if(embedded.value)window.parent.postMessage({kind:'order-detail-frame',channel,action,...extra},window.location.origin)}
function state(){const content=primary?primary.getBoundingClientRect().bottom+window.scrollY:0;send('state',{dirty:dirty(),busy:pending>0,subdialog:subdialog(),height:content?Math.ceil(content+16):0})}
function remember(){document.querySelectorAll<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>('.order-embed-primary input,.order-embed-primary textarea,.order-embed-primary select,.ant-modal-wrap input,.ant-modal-wrap textarea,.ant-modal-wrap select').forEach(el=>{if(!baseline.has(el))baseline.set(el,el.value)})}
function scan(){
 if(stopped || !embedded.value)return
 remember()
 if(!primary){primary=Array.from(document.querySelectorAll<HTMLElement>('.ant-drawer-open')).find(el=>el.getBoundingClientRect().height>0) || null;if(primary){primary.classList.add('order-embed-primary');ready.value=true;send('ready')}}
 if(!primary && !opening){const controls=Array.from(document.querySelectorAll<HTMLElement>('#appmain .admin-action-content a,#appmain .admin-action-content button,#appmain .admin-action-content span,#appmain .order-action-content a,#appmain .order-action-content button,#appmain .order-action-content span,#appmain .command-btn,#appmain td a,#appmain td button,#appmain td span.pointer'));const button=orderDetailOpener(controls);if(button){opening=true;button.click();void Promise.resolve().then(()=>{opening=false})}}
 if(!primary && Date.now()-started>15000 && !error.value){error.value='订单详情暂未加载完成，请点击顶部刷新重试';send('error',{message:error.value})}
 state()
}
function onKey(event:KeyboardEvent){
 if(!embedded.value || !['Escape','ArrowLeft','ArrowRight'].includes(event.key))return
 if(subdialog())return
 if(event.key!=='Escape' && (editingOrderTarget(event.target) || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.isComposing))return
 event.preventDefault();event.stopImmediatePropagation();send('key',{key:event.key,dirty:dirty(),busy:pending>0,subdialog:false})
}
function input(){state()}
function finished(event:Event){const {config,success}=(event as CustomEvent).detail;if(!writes.has(config))return;const saved=writes.get(config) || new Map<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement,string>();writes.delete(config);pending=Math.max(0,pending-1);if(success)saved.forEach((value,el)=>{baseline.set(el,value)});state();if(success)send('saved')}
onMounted(()=>{
 if(!embedded.value)return
 document.documentElement.classList.add('order-detail-embedded')
 requestId=service.interceptors.request.use(async config=>{
  if(orderWrite(config)){
   // 实际业务接口继续执行自己的权限及状态校验；提交前先核对明细仍可访问。
   pending++;state()
   try{await service.get('order/allOrders/'+route.query.focusOrderDetailId);if(stopped)throw new Error('订单窗口已关闭，请重新打开')}catch(reason){pending=Math.max(0,pending-1);state();throw reason}
   const payload=typeof config.data==='string'?config.data:JSON.stringify(config.data || {});const saved=new Map<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement,string>();baseline.forEach((_,el)=>{if(payload.includes(JSON.stringify(el.value)))saved.set(el,el.value)});writes.set(config,saved);state()
  }
  return config
 })
 window.addEventListener('order-request-finished',finished)
 document.addEventListener('keydown',onKey,true);document.addEventListener('input',input,true);document.addEventListener('change',input,true)
 observer=new MutationObserver(scan);observer.observe(document.body,{childList:true,subtree:true})
 timer=setInterval(scan,500);scan()
})
onBeforeUnmount(()=>{stopped=true;observer?.disconnect();if(timer)clearInterval(timer);if(requestId>=0)service.interceptors.request.eject(requestId);window.removeEventListener('order-request-finished',finished);document.documentElement.classList.remove('order-detail-embedded');document.removeEventListener('keydown',onKey,true);document.removeEventListener('input',input,true);document.removeEventListener('change',input,true)})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (embedded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(error.value || (ready.value?'原订单操作':'正在读取原订单详情…')), 1))
      : _createCommentVNode("", true),
    (embedded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})